type EndpointParams = Record<string, string | number>

export const buildEndpoint = (endpoint: string, params: EndpointParams): string => {
    return Object.entries(params).reduce((path, [key, value]) => path.replace(`{${key}}`, String(value)), endpoint)
}
